import legacyGraphQLClient from "@/services/graphql/LegacyGraphQLClient";

const ARCHIVE_ALERT = `mutation ArchiveNotification($input: ArchiveNotificationInput!) {
  archiveNotification(input: $input) {
    notification {
      id
      isArchived
    }
  }
}`;

export async function postArchiveAlert(input: {
  id: string;
  isArchived: boolean;
}) {
  legacyGraphQLClient.setEndpoint(process.env.ISTATION_ALERTS_API_URL || '/graphql');
  const response = await legacyGraphQLClient.mutate(ARCHIVE_ALERT, { input });
  if (response.errors) {
    throw new Error(response.errors[0].message);
  }
  return response.data;
}
